import React from 'react';
import BlogPostCard from './BlogPostCard';
import Icon from '../../../components/AppIcon';

const BlogGrid = ({ posts = [], onReadMore, loading }) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-12 md:py-16">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-muted-foreground">Loading articles...</p>
      </div>
    );
  }

  if (!posts.length) {
    return (
      <div className="flex flex-col items-center justify-center py-12 md:py-16 bg-card rounded-lg">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mb-4">
          <Icon name="FileText" size={32} color="var(--color-muted-foreground)" />
        </div>
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground mb-2">
          No Articles Found
        </h3>
        <p className="text-sm md:text-base text-muted-foreground text-center max-w-md">
          We couldn't find any articles matching your criteria. Try adjusting your filters or search query.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
      {posts.map((post) => (
        <BlogPostCard
          key={post._id}
          post={post}
          onReadMore={onReadMore}
        />
      ))}
    </div>
  );
};

export default BlogGrid;
